import ImpersonationBanner from "@/components/layout/components/ImpersonationBanner";

interface ContractorPanelVisitsHeaderProps {
  title: string;
  description?: string;
  className?: string;
  rightElement?: React.ReactNode;
}

export const ContractorPanelVisitsHeader = ({
  title,
  description,
  className,
  rightElement,
}: ContractorPanelVisitsHeaderProps) => {
  return (
    <div
      className={`flex items-center justify-between gap-3 pb-4 border-b ${className || ""}`}
    >
      <div className="flex items-center gap-2 min-w-0">
        <div className="min-w-0">
          <h1 className="text-lg font-semibold text-gray-900 truncate">
            {title}
          </h1>
          {description && (
            <p className="text-gray-600 text-sm">{description}</p>
          )}
        </div>
        <ImpersonationBanner onlyIcon />
      </div>
      <div className="shrink-0 flex items-center justify-center">
        {rightElement}
      </div>
    </div>
  );
};
